import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var ButtonCss = i`
  :host {
    font-family: var(--isceco-font);
    display: block;
    pointer-events: none;
  }

  .small {
    padding: 4px 10px;
    height: auto;
  }

  button {
    font: inherit;
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: none;
    padding: 0 20px;
    height: 48px;
    cursor: pointer;
    pointer-events: auto;
  }

  i {
    pointer-events: none;
    text-decoration: none !important;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 50%;
  }

  button:active, button:focus {
    outline: 4px solid var(--isceco-color-blue-300);
  }

  .primary {
    border: 2px solid var(--isceco-color-blue-500);
    background-color: var(--isceco-color-blue-500);
    color: var(--isceco-color-white-500);
  }

  .primary:hover {
    background-color: var(--isceco-color-blue-700);
    border-color: var(--isceco-color-blue-700);
  }

  .secondary {
    border: 2px solid var(--isceco-color-blue-500);
    background-color: transparent;
    color: var(--isceco-color-blue-500);
  }

  .secondary:hover {
    background-color: var(--isceco-color-blue-300);
  }

  .danger {
    border: 2px solid var(--isceco-color-red-500);
    background-color: var(--isceco-color-red-500);
    color: var(--isceco-color-white-500);
  }

  .danger:hover {
    background-color: var(--isceco-color-red-700);
    border-color: var(--isceco-color-red-700);
  }

  .danger:active, .danger:focus {
    outline: 4px solid var(--isceco-color-red-300);
  }

  .warning {
    border: 2px solid var(--isceco-color-yellow-500);
    background-color: var(--isceco-color-yellow-500);
    color: var(--isceco-color-black-500);
  }

  .warning:hover {
    background-color: var(--isceco-color-yellow-700);
    border-color: var(--isceco-color-yellow-700);
  }

  .warning:active, .warning:focus {
    outline: 4px solid var(--isceco-color-yellow-300);
  }

  .success {
    border: 2px solid var(--isceco-color-green-500);
    background-color: var(--isceco-color-green-500);
    color: var(--isceco-color-white-500);
  }

  .success:hover {
    background-color: var(--isceco-color-green-700);
    border-color: var(--isceco-color-green-700);
  }

  .success:active, .success:focus {
    outline: 4px solid var(--isceco-color-green-300);
  }

  .tertiary {
    border: 2px solid transparent;
    background-color: transparent;
    color: var(--isceco-color-blue-500);
    font-weight: bold;
  }

  .tertiary:hover {
    text-decoration: underline;
  }

  .tertiary:active, .tertiary:focus {
    outline: none;
  }
`;
export { ButtonCss as default };
